const UserReviewShell = () => null

export default UserReviewShell
